<div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="row">{{ "log-message.title" | translate }}</h2>
    <div *ngIf="topMenuIcons.length > 0">
        <ng-container *ngFor="let action of topMenuIcons">
            <button mat-raised-button *ngIf="!action.hide" [routerLink]="action.routerLink"
                (click)="this[action.clickMethod]()">
                <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
            </button>
        </ng-container>
    </div>
</div>
<form [formGroup]="detailForm">
    <div fxLayout="column">
        <div fxLayout="row wrap" fxLayoutGap="40px">
            <mat-form-field *ngIf="columnsVisible.get('id')" [ngStyle]="{
            'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
            'min-width.px': 300
          }">
                <mat-label> {{ "log-message.id" | translate }} </mat-label>
                <input matInput [ngStyle]="{
              'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
              'min-width.px': 300
            }" formControlName="id" />
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('author')" [ngStyle]="{
          'width.ch': detailForm.controls['author'].value ? detailForm.controls['author'].value.length : 10,
          'min-width.px': 300
        }">
                <mat-label>{{ "log-message.author" | translate }}</mat-label>
                <input matInput class="form-control" [disabled]='true'
                    value="{{ logMessage && logMessage.author ? logMessage.author.displayName : '' }}" [ngStyle]="{
            'width.ch': detailForm.controls['author'].value ? detailForm.controls['author'].value.length : 10,
            'min-width.px': 300
          }"  />
                <mat-error *ngIf="detailForm.controls['author'].errors?.['required']">
                    {{ "error.required" | translate }}
                </mat-error>
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('created')" [ngStyle]="{
            'width.ch': detailForm.controls['created'].value ? detailForm.controls['created'].value.length : 10,
            'min-width.px': 300
         }">
                <mat-label>{{ "log-message.creation-date" | translate }}</mat-label>
                <input matInput [disabled]='true' value="{{ logMessage.created | date:'yyyy-MM-dd HH:mm' }}"
                    class="form-control" [ngStyle]="{
             'width.ch': detailForm.controls['created'].value ? detailForm.controls['created'].value.length : 10,
             'min-width.px': 300
         }" />
                <mat-error *ngIf="detailForm.controls['created'].errors?.['required']">
                    {{ "error.required" | translate }}
                </mat-error>
            </mat-form-field>


            <mat-form-field *ngIf="columnsVisible.get('lastModificationDate')" [ngStyle]="{
            'width.ch': detailForm.controls['lastModificationDate'].value ? detailForm.controls['lastModificationDate'].value.length : 10,
            'min-width.px': 300
         }">
                <mat-label>{{ "log-message.modification-date" | translate }}</mat-label>
                <input matInput [disabled]='true'
                    value="{{ logMessage.lastModificationDate | date:'yyyy-MM-dd HH:mm' }}" class="form-control"
                    [ngStyle]="{
             'width.ch': detailForm.controls['lastModificationDate'].value ? detailForm.controls['lastModificationDate'].value.length : 10,
             'min-width.px': 300
         }" />
                <mat-error *ngIf="detailForm.controls['lastModificationDate'].errors?.['required']">
                    {{ "error.required" | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="40px">
            <mat-form-field *ngIf="columnsVisible.get('subject')" [ngStyle]="{
      'width.ch': detailForm.controls['subject'].value ? detailForm.controls['subject'].value.length : 10,
      'min-width.px': 640
    }">
                <mat-label>{{ "log-message.subject" | translate }}</mat-label>
                <input matInput class="form-control" [ngStyle]="{
        'width.ch': detailForm.controls['subject'].value ? detailForm.controls['subject'].value.length : 10,
        'min-width.px': 600
      }" formControlName="subject" />
                <mat-error *ngIf="detailForm.controls['subject'].errors?.['required']">
                    {{ "error.required" | translate }}
                </mat-error>
            </mat-form-field>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="40px">

            <mat-form-field *ngIf="columnsVisible.get('messageType')" [ngStyle]="{
    'width.ch': detailForm.controls['messageType'].value ? detailForm.controls['messageType'].value.length : 10,
    'min-width.px': 300
  }">
                <mat-label>{{ "log-message.message-type" | translate }}</mat-label>
                <input matInput class="form-control" [ngStyle]="{
      'width.ch': detailForm.controls['messageType'].value ? detailForm.controls['messageType'].value.length : 10,
      'min-width.px': 300
    }" formControlName="messageType" />
                <mat-error *ngIf="detailForm.controls['messageType'].errors?.['required']">
                    {{ "error.required" | translate }}
                </mat-error>
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('messageModel')" [ngStyle]="{
    'width.ch': detailForm.controls['messageModel'].value ? detailForm.controls['messageModel'].value.length : 10,
    'min-width.px': 300
  }">
                <mat-label>{{ "log-message.message-model" | translate }}</mat-label>
                <input matInput class="form-control" [ngStyle]="{
      'width.ch': detailForm.controls['messageModel'].value ? detailForm.controls['messageModel'].value.length : 10,
      'min-width.px': 300
    }" formControlName="messageModel" />
                <mat-error *ngIf="detailForm.controls['messageType'].errors?.['required']">
                    {{ "error.required" | translate }}
                </mat-error>
            </mat-form-field>


            <mat-form-field *ngIf="columnsVisible.get('modelId')" [ngStyle]="{
                'width.ch': detailForm.controls['modelId'].value ? detailForm.controls['modelId'].value.length : 10,
                'min-width.px': 300
              }">
                            <mat-label>{{ "log-message.model-id" | translate }}</mat-label>
                            <input matInput class="form-control" [ngStyle]="{
                  'width.ch': detailForm.controls['modelId'].value ? detailForm.controls['modelId'].value.length : 10,
                  'min-width.px': 300
                }" formControlName="modelId" />
                            <mat-error *ngIf="detailForm.controls['modelId'].errors?.['required']">
                                {{ "error.required" | translate }}
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field *ngIf="columnsVisible.get('startChainage')" [ngStyle]="{
                            'width.ch': detailForm.controls['startChainage'].value ? detailForm.controls['startChainage'].value.length : 10,
                            'min-width.px': 200
                          }">
                        <mat-label>{{ "log-message.start-chainage" | translate }}</mat-label>
                        <input matInput type="number" class="form-control" [ngStyle]="{
                              'width.ch': detailForm.controls['startChainage'].value ? detailForm.controls['startChainage'].value.length : 10,
                              'min-width.px': 180
                            }" formControlName="startChainage" [step]="countDecimalPlaces(detailForm.controls['startChainage'].value)"/>
                        <mat-error *ngIf="detailForm.controls['startChainage'].errors?.['required']">
                          {{ "error.required" | translate }}
                        </mat-error>
                        <mat-error *ngIf="detailForm.controls['startChainage'].errors?.['pattern']">{{ "error.number_pattern" |
                          translate }}</mat-error>
                      </mat-form-field>

        </div>
        <div fxLayout="row wrap" fxLayoutGap="40px"></div>
        <mat-form-field *ngIf="columnsVisible.get('body')" [ngStyle]="{
    'width.ch': detailForm.controls['body'].value ? detailForm.controls['body'].value.length : 10,
    'min-width.px': 640
  }">
            <mat-label>{{ "log-message.body" | translate }}</mat-label>
            <textarea id="body" matInput class="form-control" [ngStyle]="{
              'width.ch':  680
            }" cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="4" cdkAutosizeMaxRows="10"
                cols="10" formControlName="body"></textarea>
        </mat-form-field>

        <div style="margin-top: 15px;" [hidden]="this.id === 'new'">
            <button mat-raised-button (click)="this.gotoDetail()">
                {{ "log-message.button-to-detail" | translate }}
            </button>
        </div>

    </div>
</form>